import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";

function Commission() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  let user = "";

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);

  const [search, setSearch] = useState(user);
  const [allMember, setAllMember] = useState(0);
  const [todate, setTodate] = useState("");
  const [formdate, setFromdate] = useState("");

  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.post(
        "/InActiveMemberList",
        {
          loginid: userId,
          uid: search || "0",
          fromdate: formdate,
          todate: todate,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      console.log("InActiveMemberList", responceRight);
      responceRight = responceRight.data.data[0];
      setAllMember(responceRight?.length);
      setleftreferralApi([]);
      let arrayLeft = [];

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: item.row,
          user_id: `${item?.uid}`,
          f_name: `${item?.f_name}`,
          email: `${item?.email}`,
          mobile: `${item?.mobile}`,
          sid: `${item?.sid}`,
          password: item?.password,
          ipaddress: item?.ipaddress,
          edate: item?.edate,
        });

        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost,
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "User Id", accessor: "user_id" },
      { Header: "Name", accessor: "f_name" },
      { Header: "Mobile No", accessor: "mobile" },
      { Header: "Email Id", accessor: "email" },
      { Header: "Sponsor Id", accessor: "sid" },
      //{ Header: "Wallet Address", accessor: "password" },
      //{ Header: "Login IP Address", accessor: "ipaddress" },
      { Header: "Registration Date", accessor: "edate" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">In-Active MemberList Report</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-3">
                      <input
                        class="form-control in-ip-1"
                        id="uid"
                        onChange={(e) => setSearch(e.target.value)}
                        name="uid"
                        placeholder="Search By User Id or Name or Email"
                        type="text"
                        value={search}
                      />
                    </div>
                    <div class="col-md-3">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setFromdate(e.target.value)}
                        value={formdate}
                        id="fdate"
                        name="fdate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-3">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setTodate(e.target.value)}
                        value={todate}
                        id="tdate"
                        name="tdate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-3">
                      <input
                        type="reset"
                        id="btnsearch"
                        formmethod="get"
                        onClick={() => referral_API()}
                        class="btn btn-lg btn-primary"
                        value="Search"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <b>
                      <p>Total Count: {allMember}</p>
                    </b>

                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={currentPostleft} columns={my_team.cols} />

                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Commission;
